export const ESTADO_CESION_ACEPTACION = {
  CREADA: 1,
  COMUNICADA: 2,
  ACEPTADA_MANUALMENTE: 3,
  ACEPTADA: 4,
  CANCELADA: 5,
  FINALIZADA: 6,
  RECHAZADA: 7,
} as const

export type EstadoCesionAceptacionType =
  (typeof ESTADO_CESION_ACEPTACION)[keyof typeof ESTADO_CESION_ACEPTACION]
